<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:header></template>
      <template v-slot:actions>
        <a-btn-refresh @click="$refs.table.updateData()" />
        <a-btn-add :icon="'far fa-plus-square'" :title="'Создать'" v-if="getAccess('agentSell.create')" @click="createNew()" />
      </template>
      <portal to="v-main">
        <s-edit-form v-model="showEditDialog" :m="m" :configForm="{ head: configHead, title: configHead.title, api: url }" :id="idEdit" :opt="{}" />
      </portal>
      <a-table-f-api
        ref="table"
        :api="url"
        :model="getModelList(m)"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
      />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, keyDetect, genModel, doubleClickDetect } from "@/components/mixings";
export default {
  mixins: [getAccess, keyDetect, genModel, doubleClickDetect],

  components: {
    ViewItem: () => import("./views/agentSellView"),
  },
  data() {
    return {
      initEditDialog: 0,
      idEdit: 0,
      idItemShow: 0,
      showEditDialog: false,
      m: this.$store.getters["config/get"].models.agentSell,
      title: "",
      m2: {
        title: "Агентские сделки",
        accessName: "agentSell",
        api: "/accounting/doc/agent_sell",
        apiStatus: "/accounting/doc/agent_sell",

        cash: { accDocName: "AgentObject", operationsCash: { in: [57], out: [58] }, field_parent_id: "agent_object_id" },
        statuses: [
          { value: null, text: "Черновик", next: [2], action: "Освободить", field: "status" },
          { value: 0, text: "Черновик", next: [2], action: "Освободить", field: "status" },
          { value: 2, text: "Проведен", next: [1], action: "Провести", field: "status" },
        ],
        operationsCash: { in: [57], out: [58] },
        list: [
          { name: "id", title: "#", type: "number", sortable: true, width: 30, hidden: true },
          { name: "code_doc", title: "№", type: "number", sortable: true, width: 30 },
          {
            name: "agent_object_name",
            title: "Агентский объект",
            type: "string",
            filter: {
              name: "agent_object_id",
              type: "selectapi",
              api: { type: "post", api: "/report_sql", data: { name: "getAgentObjectsList", params: { status: [1, 2] } } },
            },
            style: "white-space: normal;",
            sortable: true,
            width: 150,
          },
          { name: "client_id", title: "Клиент", type: "select", dir: "client", style: "white-space: normal;", sortable: true, width: 150 },
          { name: "city", title: "Город", type: "string", filter: { name: "city", type: "select", options: "city" }, sortable: true, width: 150 },
          { name: "address", title: "Адрес", type: "string", sortable: true, width: 300, style: "white-space: normal;" },
          { name: "status", title: "Статус", type: "select", sourceList: "statuses", sortable: true },
        ],
        viewForm1: { fields: "date_doc,client_id,amount" },
        viewLeft: { fields: "agent_object.name,agent_object.city,agent_object.address" },
        form: [
          {
            name: "agent_object_id",
            title: "Агентский объект",
            type: "selectapi",
            api: { type: "post", api: "/report_sql", data: { name: "getAgentObjectsList", params: { status: [1, 2] } } },
            validator: ["req", "unique"],
            unique: { api: "/accounting/doc/agent_sell", errorText: "Уже есть созданная сделка по этому объекту" },
          },
          { name: "client_id", title: "Клиент", type: "selectapi", api: "mechti/clients/select", optionsFilter: { client_type: "bit#6" } },
          { name: "amount", title: "Сумма", validator: ["req"], type: "number" },
          { name: "docs", title: "Документация", type: "filesdata", category: 1, hiddenCreate: true },
          { name: "status", default: 0, hidden: true },
          { name: "filesAdd", default: [], hidden: true },
          { name: "date_doc", title: "Дата", type: "date" },
          { name: "agent_object.name", title: "Название", type: "string" },
          { name: "agent_object.city", title: "Город", type: "string" },
          { name: "agent_object.address", title: "Адрес", type: "string" },
        ],
        config: {
          createForm: {
            fields: "agent_object_id,client_id,amount,status",
            fieldsRO: "",
            fieldsForm: "agent_object_id,client_id,amount",
          },
          editForm: {
            fields: "agent_object_id,client_id,amount,docs,status",
            fieldsRO: "",
            fieldsForm: "agent_object_id,client_id,amount,docs",
          },
          viewForm1: {
            fields: "agent_object_id,client_id,amount",
            fieldsRO: "",
            fieldsForm: "",
          },
        },
      },
      defaults: {
        sort: { key: "id", order: "DESC" },
        paramName: "agentSell",
      },
      infoData: null,
      infoModel: null,
    };
  },
  created() {
    this.$root.title = this.m.title;
  },
  watch: {
    initEditDialog1(v) {
      if (v == 1) {
        this.enableDialog();
      } else {
        this.showEditDialog = true;
      }
    },
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  computed: {
    url() {
      return this.m.api;
    },
    configHead() {
      let config = JSON.parse(JSON.stringify(this.m?.config.createForm || {}));
      return config || {};
    },
  },
  methods: {
    enableDialog() {
      this.$nextTick(() => {
        //this.showEditDialog = true;
        this.initEditDialog++;
      });
    },
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },

    onDoubleClick(d) {
      this.idItemShow = d.row.id;
    },

    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.initEditDialog++;
      this.showEditDialog = true;
    },
  },
};
</script>
